module.exports = __webpack_public_path__ + "static/img/DLJG.f30173b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/DLJG.png
// module id = 6cM6
// module chunks = 1